App.directive('autofocus', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    link : function($scope, $element, attrs) {
      autofocusVal = $scope.$eval(attrs.autofocus)
      if(typeof(autofocusVal) === 'undefined' || autofocusVal === true){
        $timeout(() => {
          $element[0].focus()
        })
      }
    }
  }
}]);
